var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chat-search"},[_c('b-input',{attrs:{"placeholder":"Search"},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}}),_c('i',{staticClass:"la la-search"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }